import { render, staticRenderFns } from "./CommandEditor.vue?vue&type=template&id=57165d32&"
import script from "./CommandEditor.vue?vue&type=script&lang=js&"
export * from "./CommandEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports